import script from "./LuckDraw.vue?vue&type=script&setup=true&lang=js"
export * from "./LuckDraw.vue?vue&type=script&setup=true&lang=js"

import "./LuckDraw.vue?vue&type=style&index=0&id=89980690&lang=scss&scoped=true"

import exportComponent from "D:\\project2025\\luck-draw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89980690"]])

export default __exports__